// extracted by mini-css-extract-plugin
export default {"title":"topic-dialog_title__Ey2Ax","field":"topic-dialog_field__9XH7h","line":"topic-dialog_line__oMtCC","content":"topic-dialog_content__AM-3Y"};